import { CoreLink } from '@uncinc/react-drupal-core';
import React from 'react';
import config from 'react-global-configuration';

import './style.scss';

const NodeEventTeaser = ({ entity, delta = 0 }) => {
  const title = entity.getIn(['title', 0, 'value'], '');
  const type = entity.getIn(['field_event_type', 0, 'entity', 'name', 0, 'value'], 'Event');
  const language = config.get('DEFAULT_LANGUAGE');
  const link = entity.getIn(['paths', language], entity.get('paths').first());

  // An event has multiple dates. The following information is based on this date. The delta prop is passed
  // to select which date.
  const date = new Date(Date.parse(entity.getIn(['field_events', delta, 'entity', 'field_date', 0, 'value'])));
  const month = date.toLocaleString('nl-NL', { month: 'short' });
  const location = entity.getIn(['field_events', delta, 'entity', 'field_location', 0, 'value'], 'Onbekend');

  return (
    <div className="NodeEventTeaser">
      <div className="NodeEventTeaser__date">
        <div className="NodeEventTeaser__date__month">{month}</div>
        <div className="NodeEventTeaser__date__day">{date.getDate()}</div>
      </div>
      <div className="NodeEventTeaser__content">
        <div className="NodeEventTeaser__content__type">{type}</div>
        <h4 className="NodeEventTeaser__content__title">
          <CoreLink to={link}>{title}</CoreLink>
        </h4>

        <div className="NodeEventTeaser__content__metadata">
          <div className="NodeEventTeaser__content__metadata__item NodeEventTeaser__content__metadata__item__date">
            <i className="icon icon-before icon-calender" />
            {`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`}
          </div>

          <div className="NodeEventTeaser__content__metadata__item">
            <i className="icon icon-before icon-marker" />
            {location}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NodeEventTeaser;
